import React from "react";
import store from "../../state/store";
import isUserLoggedIn from "../../common/helpers/isUserLoggedIn";

function FullNameNotPublic() {
  return isUserLoggedIn() ? (
    <div className="tw-p-2">
      To contribute, please enable the
      <b className="tw-px-1">
        &quot;Allow other users to view your full name&quot;
      </b>
      in your
      <a
        className="tw-pl-2"
        href={`${store.getState().varsomeHost}/account-settings/`}
      >
        Account settings
      </a>
      .
    </div>
  ) : (
    <div className="tw-p-2">
      To contribute, please
      <a
        className="tw-pl-2"
        href={`${store.getState().varsomeHost}/sign-in/?next=${
          window.location
        }`}
      >
        log in
      </a>
    </div>
  );
}

export default FullNameNotPublic;
